// Formats a DB integer order ID into a display-friendly order number.
// SC = Sierra Chart, offset makes the numbering look established from day one.
const PREFIX = "SC";
const OFFSET = 4721;

export function formatOrderNumber(id: number): string {
  return `${PREFIX}-${id + OFFSET}`;
}
